import { Children } from "react"
import { Box, Typography } from "@mui/material"
import { PageRowSection } from "../../components"
import { theme } from "../../../../utils/theme/godzilla_light"
import { AccordionComponent } from "../../../../components"
import { Trans, useTranslation } from "react-i18next"
import ContrastImage from '../../../../assets/images/svgs/impactOnPatients/contrast_icon.svg'
import LowLightImage from '../../../../assets/images/svgs/impactOnPatients/low_light_icon.svg'
import DarkAdaptationImage from '../../../../assets/images/other/dark_adaptation_icon.png'
import MicropermetryImage from '../../../../assets/images/other/microperimetry_icon.png'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TransMsg from './transMessage'

const styles = {
    expandRoundIcon: {
        width: "34px",
        height: "34px",
        borderRadius: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: 'center',
        backgroundColor: "#fff"
    },
    gaFunctionTitle: {
        ...theme.typography.opticianBodyRegular,
        color: "#1E1E22",
        fontSize: "20px",
        mt: "10px",
        mb: "27px"
    },
    collapseTitle: {
        ...theme.typography.poppinsBodySemiBold,
        fontSize: "14px",
        color: "#4B69F1"
    }
}

const ExpandIconComponent = () => (
    <Box sx={styles.expandRoundIcon}>
        <ExpandMoreIcon sx={{ color: "#00557C" }} />
    </Box>
)

const FunctionalTests = (props: any) => {
    const { t } = props

    const tempData = [
        {
            "title": "Contrast Sensitivity",
            "content": "May be used to detect abnormal visual function on patients with good BCVA<sup>4</sup>",
            "icon": ContrastImage
        },
        {
            "title": "Low-Light Visual Acuity (LLVA)",
            "content": "Deficits in LLVA are associated with higher GA lesion progression rates<sup>3</sup>",
            "icon": LowLightImage
        },
        {
            "title": "Dark Adaptation",
            "content": "Delayed dark adaptation may provide evidence of AMD before the appearance of clinical features such as drusen and focal pigmentary changes<sup>10,20</sup>",
            "icon": DarkAdaptationImage
        },
        {
            "title": "Microperimetry",
            "content": "A decrease in retinal sensitivity can correlate with lesion enlargement over time<sup>3,21</sup>",
            "icon": MicropermetryImage
        }
    ]

    return (
        <Box>
            <Typography sx={styles.gaFunctionTitle}>
                {t(TransMsg.FUNCTIONAL_GA_TITLE)}
            </Typography>
            {Children.toArray(tempData.map((item) => {
                return (
                    <AccordionComponent
                        title={item.title}
                        titleSx={styles.collapseTitle}
                        wrapperSx={{ boxShadow: "none", backgroundColor: "#F8F8F8" }}
                        summarySx={{ pl: "0px" }}
                        leftElement={<img src={item.icon} style={{ width: "45px", height: "45px", marginRight: "20px" }} alt="summary-icon" />}
                        customExpandIcon={<ExpandIconComponent />}>
                        <Typography sx={{ ...theme.typography.components.sectionDescription, mt: "-10px", fontSize: "1rem", textAlign: "left" }}>
                            <Trans
                                i18nKey={item.content}
                                components={{ sup: <sup /> }}
                            />
                        </Typography>
                    </AccordionComponent>
                )
            }))}
        </Box>
    )
}

const VisualAcuity = () => {
    const { t } = useTranslation()

    return (
        <PageRowSection
            title={t(TransMsg.ACUITY_TITLE)}
            description={t(TransMsg.ACUITY_DESCRIPTION)}
            descriptionSx={{ ...theme.typography.montseratBodyRegular, lineHeight: "150%", fontSize: "18px" }}
            rightElement={<FunctionalTests t={t} />}
        />
    )
}

export default VisualAcuity